import { CheckIcon } from "@heroicons/react/24/outline"
import { useTranslation } from "react-i18next"

const ITEMS = ["mindMaps", "youtube", "aiHelper", "chat", "plan"]

export default function WhatYouGet() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <h2 className="vm-heading">
        {t("pages.checkout.paywall.whatYouGet.heading")}
      </h2>

      <ul className="vm-card space-y-4 p-5">
        {ITEMS.map((item) => (
          <li className="flex items-start gap-3" key={item}>
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-vm-primary-soft">
              <CheckIcon className="h-4 w-4 text-vm-primary" />
            </span>
            <span className="text-[15px] leading-snug text-vm-ink">
              {t(`pages.checkout.paywall.whatYouGet.items.${item}`)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
